/**
 * Google Fonts for the FontFamily component.
 */

const fonts = {};
fonts.ABeeZee = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Abel = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Abhaya Libre'] = {
	v: ['regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'sinhala', 'latin'],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Abril Fatface'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Aclonica = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Acme = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Actor = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Adamina = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Advent Pro'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'greek', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Aguafina Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Akronim = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Aladin = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Aldrich = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Alef = {
	v: ['regular', '700'],
	subset: ['hebrew', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Alegreya = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '500', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Alegreya SC'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '500', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Alegreya Sans'] = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Alegreya Sans SC'] = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Alex Brush'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Alfa Slab One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Alice = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Alike = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Alike Angular'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Allan = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Allerta = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Allerta Stencil'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Allura = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Almendra = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Almendra Display'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Almendra SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Amarante = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Amaranth = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Amatic SC'] = {
	v: ['regular', '700'],
	subset: ['cyrillic', 'latin-ext', 'hebrew', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Amethysta = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Amiko = {
	v: ['regular', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '600', '700'],
	i: ['normal'],
};
fonts.Amiri = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Amita = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Anaheim = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Andada = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Andika = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Angkor = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Annie Use Your Telescope'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Anonymous Pro'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'latin-ext', 'greek', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Antic = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Antic Didone'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Antic Slab'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Anton = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Arapey = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Arbutus = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Arbutus Slab'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Architects Daughter'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Archivo = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Archivo Black'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Archivo Narrow'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Aref Ruqaa'] = {
	v: ['regular', '700'],
	subset: ['arabic', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Arima Madurai'] = {
	v: ['100', '200', '300', 'regular', '500', '700', '800', '900'],
	subset: ['latin-ext', 'tamil', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '700', '800', '900'],
	i: ['normal'],
};
fonts.Arimo = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'hebrew',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Arizonia = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Armata = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Arsenal = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Artifika = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Arvo = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Arya = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Asap = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Asap Condensed'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts.Asar = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Asset = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Assistant = {
	v: ['200', '300', 'regular', '600', '700', '800'],
	subset: ['hebrew', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800'],
	i: ['normal'],
};
fonts.Astloch = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Asul = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Athiti = {
	v: ['200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Atma = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'bengali', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Atomic Age'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Aubrey = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Audiowide = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Autour One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Average = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Average Sans'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Averia Gruesa Libre'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Averia Libre'] = {
	v: ['300', '300italic', 'regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['300', '400', '700'],
	i: ['normal', 'italic'],
};
fonts['Averia Sans Libre'] = {
	v: ['300', '300italic', 'regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['300', '400', '700'],
	i: ['normal', 'italic'],
};
fonts['Averia Serif Libre'] = {
	v: ['300', '300italic', 'regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['300', '400', '700'],
	i: ['normal', 'italic'],
};
fonts['Bad Script'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bahiana = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Baloo = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Bhai'] = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Bhaijaan'] = {
	v: ['regular'],
	subset: ['latin-ext', 'arabic', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Bhaina'] = {
	v: ['regular'],
	subset: ['latin-ext', 'oriya', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Chettan'] = {
	v: ['regular'],
	subset: ['malayalam', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Da'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'bengali', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Paaji'] = {
	v: ['regular'],
	subset: ['latin-ext', 'gurmukhi', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Tamma'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin', 'kannada'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Tammudu'] = {
	v: ['regular'],
	subset: ['latin-ext', 'telugu', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Baloo Thambi'] = {
	v: ['regular'],
	subset: ['latin-ext', 'tamil', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Balthazar = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bangers = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Barlow = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Barlow Condensed'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Barlow Semi Condensed'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts.Barrio = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Basic = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Battambang = {
	v: ['regular', '700'],
	subset: ['khmer'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Baumans = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bayon = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Belgrano = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bellefair = {
	v: ['regular'],
	subset: ['latin-ext', 'hebrew', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Belleza = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.BenchNine = {
	v: ['300', 'regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts.Bentham = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Berkshire Swash'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bevan = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bigelow Rules'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bigshot One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bilbo = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bilbo Swash Caps'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.BioRhyme = {
	v: ['200', '300', 'regular', '700', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '700', '800'],
	i: ['normal'],
};
fonts['BioRhyme Expanded'] = {
	v: ['200', '300', 'regular', '700', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '700', '800'],
	i: ['normal'],
};
fonts.Biryani = {
	v: ['200', '300', 'regular', '600', '700', '800', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Bitter = {
	v: ['regular', 'italic', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Black And White Picture'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Black Han Sans'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Black Ops One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bokor = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Bonbon = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Boogaloo = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bowlby One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bowlby One SC'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Brawler = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bree Serif'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bubblegum Sans'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bubbler One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Buda = { v: ['300'], subset: ['latin'], weight: ['300'], i: [] };
fonts.Buenard = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Bungee = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bungee Hairline'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bungee Inline'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bungee Outline'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Bungee Shade'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Butcherman = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Butterfly Kids'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cabin = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Cabin Condensed'] = {
	v: ['regular', '500', '600', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Cabin Sketch'] = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Caesar Dressing'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cagliostro = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cairo = {
	v: ['200', '300', 'regular', '600', '700', '900'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['200', '300', '400', '600', '700', '900'],
	i: ['normal'],
};
fonts.Calligraffitti = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cambay = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Cambo = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Candal = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cantarell = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Cantata One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Cantora One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Capriola = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cardo = {
	v: ['regular', 'italic', '700'],
	subset: ['greek-ext', 'latin-ext', 'greek', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Carme = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Carrois Gothic'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Carrois Gothic SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Carter One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Catamaran = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'tamil', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Caudex = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['greek-ext', 'latin-ext', 'greek', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Caveat = {
	v: ['regular', '700'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Caveat Brush'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Cedarville Cursive'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ceviche One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Changa = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Changa One'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Chango = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Chathura = {
	v: ['100', '300', 'regular', '700', '800'],
	subset: ['telugu', 'latin'],
	weight: ['100', '300', '400', '700', '800'],
	i: ['normal'],
};
fonts['Chau Philomene One'] = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Chela One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Chelsea Market'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Chenla = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Cherry Cream Soda'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Cherry Swash'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Chewy = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Chicle = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Chivo = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts.Chonburi = {
	v: ['regular'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cinzel = {
	v: ['regular', '700', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal'],
};
fonts['Cinzel Decorative'] = {
	v: ['regular', '700', '900'],
	subset: ['latin'],
	weight: ['400', '700', '900'],
	i: ['normal'],
};
fonts['Clicker Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Coda = {
	v: ['regular', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '800'],
	i: ['normal'],
};
fonts['Coda Caption'] = {
	v: ['800'],
	subset: ['latin-ext', 'latin'],
	weight: ['800'],
	i: [],
};
fonts.Codystar = {
	v: ['300', 'regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400'],
	i: ['normal'],
};
fonts.Coiny = {
	v: ['regular'],
	subset: ['latin-ext', 'tamil', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Combo = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Comfortaa = {
	v: ['300', 'regular', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts['Coming Soon'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Concert One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Condiment = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Content = {
	v: ['regular', '700'],
	subset: ['khmer'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Contrail One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Convergence = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cookie = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Copse = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Corben = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Cormorant = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Cormorant Garamond'] = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Cormorant Infant'] = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Cormorant SC'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Cormorant Unicase'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Cormorant Upright'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Courgette = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cousine = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'hebrew',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Coustard = {
	v: ['regular', '900'],
	subset: ['latin'],
	weight: ['400', '900'],
	i: ['normal'],
};
fonts['Covered By Your Grace'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Crafty Girls'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Creepster = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Crete Round'] = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Crimson Text'] = {
	v: ['regular', 'italic', '600', '600italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Croissant One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Crushed = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cuprum = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Cute Font'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Cutive = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Cutive Mono'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Damion = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Dancing Script'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Dangrek = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['David Libre'] = {
	v: ['regular', '500', '700'],
	subset: ['latin-ext', 'hebrew', 'vietnamese', 'latin'],
	weight: ['400', '500', '700'],
	i: ['normal'],
};
fonts['Dawning of a New Day'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Days One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dekko = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Delius = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Delius Swash Caps'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Delius Unicase'] = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Della Respira'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Denk One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Devonshire = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dhurjati = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Didact Gothic'] = {
	v: ['regular'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'latin',
	],
	weight: ['400'],
	i: ['normal'],
};
fonts.Diplomata = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Diplomata SC'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Do Hyeon'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dokdo = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Domine = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Donegal One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Doppio One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dorsa = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dosis = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Dr Sugiyama'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Duru Sans'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Dynalight = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['EB Garamond'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal', 'italic'],
};
fonts['Eagle Lake'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['East Sea Dokdo'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Eater = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Economica = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Eczar = {
	v: ['regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['El Messiri'] = {
	v: ['regular', '500', '600', '700'],
	subset: ['cyrillic', 'arabic', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Electrolize = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Elsie = {
	v: ['regular', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '900'],
	i: ['normal'],
};
fonts['Elsie Swash Caps'] = {
	v: ['regular', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '900'],
	i: ['normal'],
};
fonts['Emblema One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Emilys Candy'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Encode Sans'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Encode Sans Condensed'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Encode Sans Expanded'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Encode Sans Semi Condensed'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Encode Sans Semi Expanded'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Engagement = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Englebert = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Enriqueta = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Erica One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Esteban = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Euphoria Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ewert = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Exo = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Exo 2'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Expletus Sans'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Fanwood Text'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Farsan = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fascinate = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fascinate Inline'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Faster One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fasthand = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fauna One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Faustina = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts.Federant = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Federo = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Felipa = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fenix = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Finger Paint'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fira Mono'] = {
	v: ['regular', '500', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'latin',
	],
	weight: ['400', '500', '700'],
	i: ['normal'],
};
fonts['Fira Sans'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Fira Sans Condensed'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Fira Sans Extra Condensed'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Fjalla One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fjord One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Flamenco = {
	v: ['300', 'regular'],
	subset: ['latin'],
	weight: ['300', '400'],
	i: ['normal'],
};
fonts.Flavors = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fondamento = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Fontdiner Swanky'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Forum = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Francois One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Frank Ruhl Libre'] = {
	v: ['300', 'regular', '500', '700', '900'],
	subset: ['latin-ext', 'hebrew', 'latin'],
	weight: ['300', '400', '500', '700', '900'],
	i: ['normal'],
};
fonts['Freckle Face'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fredericka the Great'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fredoka One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Freehand = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fresca = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Frijole = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Fruktur = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Fugaz One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['GFS Didot'] = {
	v: ['regular'],
	subset: ['greek'],
	weight: ['400'],
	i: ['normal'],
};
fonts['GFS Neohellenic'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['greek'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Gabriela = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gaegu = {
	v: ['300', 'regular', '700'],
	subset: ['korean', 'latin'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts.Gafata = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Galada = {
	v: ['regular'],
	subset: ['bengali', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Galdeano = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Galindo = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Gamja Flower'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Gentium Basic'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Gentium Book Basic'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Geo = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Geostar = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Geostar Fill'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Germania One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gidugu = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Gilda Display'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Give You Glory'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Glass Antiqua'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Glegoo = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Gloria Hallelujah'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Goblin One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Gochi Hand'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gorditas = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Gothic A1'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['korean', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Goudy Bookletter 1911'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Graduate = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Grand Hotel'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Gravitas One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Great Vibes'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Griffy = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gruppo = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gudea = {
	v: ['regular', 'italic', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Gugi = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Gurajada = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Habibi = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Halant = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Hammersmith One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Hanalei = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Hanalei Fill'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Handlee = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Hanuman = {
	v: ['regular', '700'],
	subset: ['khmer'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Happy Monkey'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Harmattan = {
	v: ['regular'],
	subset: ['arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Headland One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Heebo = {
	v: ['100', '300', 'regular', '500', '700', '800', '900'],
	subset: ['hebrew', 'latin'],
	weight: ['100', '300', '400', '500', '700', '800', '900'],
	i: ['normal'],
};
fonts['Henny Penny'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Herr Von Muellerhoff'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Hi Melody'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Hind = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Hind Guntur'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'telugu', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Hind Madurai'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'tamil', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Hind Siliguri'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'bengali', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Hind Vadodara'] = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Holtwood One SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Homemade Apple'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Homenaje = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['IBM Plex Mono'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['IBM Plex Sans'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['IBM Plex Sans Condensed'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['IBM Plex Serif'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['IM Fell DW Pica'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['IM Fell DW Pica SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['IM Fell Double Pica'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['IM Fell Double Pica SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['IM Fell English'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['IM Fell English SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['IM Fell French Canon'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['IM Fell French Canon SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['IM Fell Great Primer'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['IM Fell Great Primer SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Iceberg = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Iceland = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Imprima = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Inconsolata = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Inder = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Indie Flower'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Inika = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Inknut Antiqua'] = {
	v: ['300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Irish Grover'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Istok Web'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Italiana = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Italianno = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Itim = {
	v: ['regular'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Jacques Francois'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Jacques Francois Shadow'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Jaldi = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Jim Nightshade'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Jockey One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Jolly Lodger'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Jomhuria = {
	v: ['regular'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Josefin Sans'] = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '300', '400', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Josefin Slab'] = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin'],
	weight: ['100', '300', '400', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Joti One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Jua = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Judson = {
	v: ['regular', 'italic', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Julee = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Julius Sans One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Junge = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Jura = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Just Another Hand'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Just Me Again Down Here'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kadwa = {
	v: ['regular', '700'],
	subset: ['devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Kalam = {
	v: ['300', 'regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts.Kameron = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Kanit = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts.Kantumruy = {
	v: ['300', 'regular', '700'],
	subset: ['khmer'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts.Karla = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Karma = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Katibeh = {
	v: ['regular'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kaushan Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kavivanar = {
	v: ['regular'],
	subset: ['latin-ext', 'tamil', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kavoon = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kdam Thmor'] = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Keania One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kelly Slab'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kenia = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Khand = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Khmer = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Khula = {
	v: ['300', 'regular', '600', '700', '800'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '600', '700', '800'],
	i: ['normal'],
};
fonts['Kirang Haerang'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kite One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Knewave = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kosugi = {
	v: ['regular'],
	subset: ['cyrillic', 'japanese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kosugi Maru'] = {
	v: ['regular'],
	subset: ['cyrillic', 'japanese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kotta One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Koulen = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kranky = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kreon = {
	v: ['300', 'regular', '700'],
	subset: ['latin'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts.Kristi = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Krona One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kumar One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Kumar One Outline'] = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Kurale = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['La Belle Aurore'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Laila = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Lakki Reddy'] = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lalezar = {
	v: ['regular'],
	subset: ['latin-ext', 'arabic', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lancelot = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lateef = {
	v: ['regular'],
	subset: ['arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lato = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '300', '400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['League Script'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Leckerli One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ledger = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lekton = {
	v: ['regular', 'italic', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Lemon = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lemonada = {
	v: ['300', 'regular', '600', '700'],
	subset: ['latin-ext', 'arabic', 'vietnamese', 'latin'],
	weight: ['300', '400', '600', '700'],
	i: ['normal'],
};
fonts['Libre Barcode 128'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Barcode 128 Text'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Barcode 39'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Barcode 39 Extended'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Barcode 39 Extended Text'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Barcode 39 Text'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Libre Baskerville'] = {
	v: ['regular', 'italic', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Libre Franklin'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Life Savers'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Lilita One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Lily Script One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Limelight = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Linden Hill'] = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Lobster = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Lobster Two'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Londrina Outline'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Londrina Shadow'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Londrina Sketch'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Londrina Solid'] = {
	v: ['100', '300', 'regular', '900'],
	subset: ['latin'],
	weight: ['100', '300', '400', '900'],
	i: ['normal'],
};
fonts.Lora = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Love Ya Like A Sister'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Loved by the King'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Lovers Quarrel'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Luckiest Guy'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Lusitana = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Lustria = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['M PLUS 1p'] = {
	v: ['100', '300', 'regular', '500', '700', '800', '900'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'japanese',
		'latin-ext',
		'hebrew',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700', '800', '900'],
	i: ['normal'],
};
fonts['M PLUS Rounded 1c'] = {
	v: ['100', '300', 'regular', '500', '700', '800', '900'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'japanese',
		'latin-ext',
		'hebrew',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700', '800', '900'],
	i: ['normal'],
};
fonts.Macondo = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Macondo Swash Caps'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mada = {
	v: ['200', '300', 'regular', '500', '600', '700', '900'],
	subset: ['arabic', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '900'],
	i: ['normal'],
};
fonts.Magra = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Maiden Orange'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Maitree = {
	v: ['200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Mako = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mallanna = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mandali = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Manuale = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts.Marcellus = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Marcellus SC'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Marck Script'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Margarine = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Markazi Text'] = {
	v: ['regular', '500', '600', '700'],
	subset: ['latin-ext', 'arabic', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Marko One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Marmelad = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Martel = {
	v: ['200', '300', 'regular', '600', '700', '800', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Martel Sans'] = {
	v: ['200', '300', 'regular', '600', '700', '800', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Marvel = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Mate = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Mate SC'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Maven Pro'] = {
	v: ['regular', '500', '700', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '700', '900'],
	i: ['normal'],
};
fonts.McLaren = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Meddon = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.MedievalSharp = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Medula One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Meera Inimai'] = {
	v: ['regular'],
	subset: ['tamil', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Megrim = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Meie Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Merienda = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Merienda One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Merriweather = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Merriweather Sans'] = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '700', '800'],
	i: ['normal', 'italic'],
};
fonts.Metal = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Metal Mania'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Metamorphous = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Metrophobic = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Michroma = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Milonga = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Miltonian = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Miltonian Tattoo'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mina = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'bengali', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Miniver = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Miriam Libre'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'hebrew', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Mirza = {
	v: ['regular', '500', '600', '700'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Miss Fajardose'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mitr = {
	v: ['200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Modak = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Modern Antiqua'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mogra = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Molengo = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Molle = {
	v: ['italic'],
	subset: ['latin-ext', 'latin'],
	weight: [],
	i: ['italic'],
};
fonts.Monda = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Monofett = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Monoton = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Monsieur La Doulaise'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Montaga = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Montez = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Montserrat = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Montserrat Alternates'] = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Montserrat Subrayada'] = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Moul = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Moulpali = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mountains of Christmas'] = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Mouse Memoirs'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mr Bedfort'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mr Dafoe'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mr De Haviland'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mrs Saint Delafield'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Mrs Sheppards'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Mukta = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Mukta Mahee'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'gurmukhi', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Mukta Malar'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'tamil', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Mukta Vaani'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts.Muli = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Mystery Quest'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.NTR = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nanum Brush Script'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nanum Gothic'] = {
	v: ['regular', '700', '800'],
	subset: ['korean', 'latin'],
	weight: ['400', '700', '800'],
	i: ['normal'],
};
fonts['Nanum Gothic Coding'] = {
	v: ['regular', '700'],
	subset: ['korean', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Nanum Myeongjo'] = {
	v: ['regular', '700', '800'],
	subset: ['korean', 'latin'],
	weight: ['400', '700', '800'],
	i: ['normal'],
};
fonts['Nanum Pen Script'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Neucha = {
	v: ['regular'],
	subset: ['cyrillic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Neuton = {
	v: ['200', '300', 'regular', 'italic', '700', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '700', '800'],
	i: ['normal', 'italic'],
};
fonts['New Rocker'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['News Cycle'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Niconne = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nixie One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Nobile = {
	v: ['regular', 'italic', '500', '500italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '500', '700'],
	i: ['normal', 'italic'],
};
fonts.Nokora = {
	v: ['regular', '700'],
	subset: ['khmer'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Norican = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Nosifer = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nothing You Could Do'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Noticia Text'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Noto Sans'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'devanagari',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Noto Sans JP'] = {
	v: ['100', '300', 'regular', '500', '700', '900'],
	subset: ['japanese', 'latin'],
	weight: ['100', '300', '400', '500', '700', '900'],
	i: ['normal'],
};
fonts['Noto Sans KR'] = {
	v: ['100', '300', 'regular', '500', '700', '900'],
	subset: ['korean', 'latin'],
	weight: ['100', '300', '400', '500', '700', '900'],
	i: ['normal'],
};
fonts['Noto Serif'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Noto Serif JP'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '900'],
	subset: ['japanese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '900'],
	i: ['normal'],
};
fonts['Noto Serif KR'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '900'],
	subset: ['korean', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '900'],
	i: ['normal'],
};
fonts['Nova Cut'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Flat'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Mono'] = {
	v: ['regular'],
	subset: ['greek', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Oval'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Round'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Script'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Slim'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Nova Square'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Numans = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Nunito = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Nunito Sans'] = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Odor Mean Chey'] = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Offside = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Old Standard TT'] = {
	v: ['regular', 'italic', '700'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Oldenburg = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Oleo Script'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Oleo Script Swash Caps'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Open Sans'] = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['300', '400', '600', '700', '800'],
	i: ['normal', 'italic'],
};
fonts['Open Sans Condensed'] = {
	v: ['300', '300italic', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['300', '700'],
	i: [],
};
fonts.Oranienbaum = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Orbitron = {
	v: ['regular', '500', '700', '900'],
	subset: ['latin'],
	weight: ['400', '500', '700', '900'],
	i: ['normal'],
};
fonts.Oregano = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Orienta = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Original Surfer'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Oswald = {
	v: ['200', '300', 'regular', '500', '600', '700'],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Over the Rainbow'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Overlock = {
	v: ['regular', 'italic', '700', '700italic', '900', '900italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Overlock SC'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Overpass = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Overpass Mono'] = {
	v: ['300', 'regular', '600', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '600', '700'],
	i: ['normal'],
};
fonts.Ovo = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Oxygen = {
	v: ['300', 'regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '700'],
	i: ['normal'],
};
fonts['Oxygen Mono'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['PT Mono'] = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['PT Sans'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['PT Sans Caption'] = {
	v: ['regular', '700'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['PT Sans Narrow'] = {
	v: ['regular', '700'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['PT Serif'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['PT Serif Caption'] = {
	v: ['regular', 'italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Pacifico = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Padauk = {
	v: ['regular', '700'],
	subset: ['myanmar', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Palanquin = {
	v: ['100', '200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Palanquin Dark'] = {
	v: ['regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Pangolin = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Paprika = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Parisienne = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Passero One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Passion One'] = {
	v: ['regular', '700', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal'],
};
fonts['Pathway Gothic One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Patrick Hand'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Patrick Hand SC'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Pattaya = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Patua One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Pavanam = {
	v: ['regular'],
	subset: ['latin-ext', 'tamil', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Paytone One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Peddana = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Peralta = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Permanent Marker'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Petit Formal Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Petrona = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Philosopher = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Piedra = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Pinyon Script'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Pirata One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Plaster = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Play = {
	v: ['regular', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Playball = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Playfair Display'] = {
	v: ['regular', 'italic', '700', '700italic', '900', '900italic'],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Playfair Display SC'] = {
	v: ['regular', 'italic', '700', '700italic', '900', '900italic'],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal', 'italic'],
};
fonts.Podkova = {
	v: ['regular', '500', '600', '700', '800'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts['Poiret One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Poller One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Poly = {
	v: ['regular', 'italic'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Pompiere = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Pontano Sans'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Poor Story'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Poppins = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Port Lligat Sans'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Port Lligat Slab'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Pragati Narrow'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Prata = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Preahvihear = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Press Start 2P'] = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'greek', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Pridi = {
	v: ['200', '300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts['Princess Sofia'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Prociono = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Prompt = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Prosto One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Proza Libre'] = {
	v: [
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal', 'italic'],
};
fonts.Puritan = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Purple Purse'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Quando = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Quantico = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Quattrocento = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Quattrocento Sans'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Questrial = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Quicksand = {
	v: ['300', 'regular', '500', '700'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['300', '400', '500', '700'],
	i: ['normal'],
};
fonts.Quintessential = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Qwigley = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Racing Sans One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Radley = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Rajdhani = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Rakkas = {
	v: ['regular'],
	subset: ['latin-ext', 'arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Raleway = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts['Raleway Dots'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ramabhadra = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ramaraja = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Rambla = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Rammetto One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ranchers = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Rancho = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ranga = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Rasa = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Rationale = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ravi Prakash'] = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Redressed = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Reem Kufi'] = {
	v: ['regular'],
	subset: ['arabic', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Reenie Beanie'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Revalia = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Rhodium Libre'] = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ribeye = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ribeye Marrow'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Righteous = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Risque = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Roboto = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Roboto Condensed'] = {
	v: ['300', '300italic', 'regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['300', '400', '700'],
	i: ['normal', 'italic'],
};
fonts['Roboto Mono'] = {
	v: [
		'100',
		'100italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '500', '700'],
	i: ['normal', 'italic'],
};
fonts['Roboto Slab'] = {
	v: ['100', '300', 'regular', '700'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['100', '300', '400', '700'],
	i: ['normal'],
};
fonts.Rochester = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Rock Salt'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Rokkitt = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Romanesco = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ropa Sans'] = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Rosario = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Rosarivo = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Rouge Script'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Rozha One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Rubik = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: ['cyrillic', 'latin-ext', 'hebrew', 'latin'],
	weight: ['300', '400', '500', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Rubik Mono One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ruda = {
	v: ['regular', '700', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700', '900'],
	i: ['normal'],
};
fonts.Rufina = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Ruge Boogie'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ruluko = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Rum Raisin'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ruslan Display'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Russo One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ruthie = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Rye = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sacramento = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sahitya = {
	v: ['regular', '700'],
	subset: ['devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Sail = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Saira = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Saira Condensed'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Saira Extra Condensed'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Saira Semi Condensed'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Salsa = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sanchez = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts.Sancreek = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sansita = {
	v: [
		'regular',
		'italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts.Sarala = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Sarina = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sarpanch = {
	v: ['regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts.Satisfy = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sawarabi Gothic'] = {
	v: ['regular'],
	subset: ['cyrillic', 'japanese', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sawarabi Mincho'] = {
	v: ['regular'],
	subset: ['japanese', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Scada = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Scheherazade = {
	v: ['regular', '700'],
	subset: ['arabic', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Schoolbell = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Scope One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Seaweed Script'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Secular One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'hebrew', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sedgwick Ave'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sedgwick Ave Display'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sevillana = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Seymour One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Shadows Into Light'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Shadows Into Light Two'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Shanti = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Share = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Share Tech'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Share Tech Mono'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Shojumaru = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Short Stack'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Shrikhand = {
	v: ['regular'],
	subset: ['latin-ext', 'gujarati', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Siemreap = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sigmar One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Signika = {
	v: ['300', 'regular', '600', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '600', '700'],
	i: ['normal'],
};
fonts['Signika Negative'] = {
	v: ['300', 'regular', '600', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '600', '700'],
	i: ['normal'],
};
fonts.Simonetta = {
	v: ['regular', 'italic', '900', '900italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '900'],
	i: ['normal', 'italic'],
};
fonts.Sintony = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Sirin Stencil'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Six Caps'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Skranji = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Slabo 13px'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Slabo 27px'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Slackey = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Smokum = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Smythe = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sniglet = {
	v: ['regular', '800'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '800'],
	i: ['normal'],
};
fonts.Snippet = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Snowburst One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sofadi One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sofia = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Song Myung'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sonsie One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sorts Mill Goudy'] = {
	v: ['regular', 'italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal', 'italic'],
};
fonts['Source Code Pro'] = {
	v: ['200', '300', 'regular', '500', '600', '700', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '900'],
	i: ['normal'],
};
fonts['Source Sans Pro'] = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['200', '300', '400', '600', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Source Serif Pro'] = {
	v: ['regular', '600', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '600', '700'],
	i: ['normal'],
};
fonts['Space Mono'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Special Elite'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Spectral = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal', 'italic'],
};
fonts['Spectral SC'] = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
	],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '500', '600', '700', '800'],
	i: ['normal', 'italic'],
};
fonts['Spicy Rice'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Spinnaker = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Spirax = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Squada One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sree Krushnadevaraya'] = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sriracha = {
	v: ['regular'],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Stalemate = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Stalinist One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Stardos Stencil'] = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts['Stint Ultra Condensed'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Stint Ultra Expanded'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Stoke = {
	v: ['300', 'regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400'],
	i: ['normal'],
};
fonts.Strait = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Stylish = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Sue Ellen Francisco'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Suez One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'hebrew', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sumana = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Sunflower = {
	v: ['300', '500', '700'],
	subset: ['korean', 'latin'],
	weight: ['300', '500', '700'],
	i: [],
};
fonts.Sunshiney = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Supermercado One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Sura = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Suranna = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Suravaram = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Suwannaphum = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Swanky and Moo Moo'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Syncopate = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Tajawal = {
	v: ['200', '300', 'regular', '500', '700', '800', '900'],
	subset: ['arabic', 'latin'],
	weight: ['200', '300', '400', '500', '700', '800', '900'],
	i: ['normal'],
};
fonts.Tangerine = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Taprom = {
	v: ['regular'],
	subset: ['khmer'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Tauri = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Taviraj = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts.Teko = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Telex = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Tenali Ramakrishna'] = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Tenor Sans'] = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Text Me One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['The Girl Next Door'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Tienne = {
	v: ['regular', '700', '900'],
	subset: ['latin'],
	weight: ['400', '700', '900'],
	i: ['normal'],
};
fonts.Tillana = {
	v: ['regular', '500', '600', '700', '800'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '500', '600', '700', '800'],
	i: ['normal'],
};
fonts.Timmana = {
	v: ['regular'],
	subset: ['telugu', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Tinos = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'hebrew',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts['Titan One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Titillium Web'] = {
	v: [
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'900',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['200', '300', '400', '600', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Trade Winds'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Trirong = {
	v: [
		'100',
		'100italic',
		'200',
		'200italic',
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'800',
		'800italic',
		'900',
		'900italic',
	],
	subset: ['latin-ext', 'thai', 'vietnamese', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal', 'italic'],
};
fonts.Trocchi = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Trochut = {
	v: ['regular', 'italic', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Trykker = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Tulpen One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Ubuntu = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'700',
		'700italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'latin',
	],
	weight: ['300', '400', '500', '700'],
	i: ['normal', 'italic'],
};
fonts['Ubuntu Condensed'] = {
	v: ['regular'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'latin',
	],
	weight: ['400'],
	i: ['normal'],
};
fonts['Ubuntu Mono'] = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'greek-ext',
		'latin-ext',
		'greek',
		'latin',
	],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Ultra = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Uncial Antiqua'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Underdog = {
	v: ['regular'],
	subset: ['cyrillic', 'latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Unica One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.UnifrakturCook = {
	v: ['700'],
	subset: ['latin'],
	weight: ['700'],
	i: [],
};
fonts.UnifrakturMaguntia = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Unkempt = {
	v: ['regular', '700'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
fonts.Unlock = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Unna = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.VT323 = {
	v: ['regular'],
	subset: ['latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Vampiro One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Varela = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Varela Round'] = {
	v: ['regular'],
	subset: ['latin-ext', 'hebrew', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Vast Shadow'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Vesper Libre'] = {
	v: ['regular', '500', '700', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400', '500', '700', '900'],
	i: ['normal'],
};
fonts.Vibur = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Vidaloka = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Viga = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Voces = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Volkhov = {
	v: ['regular', 'italic', '700', '700italic'],
	subset: ['latin'],
	weight: ['400', '700'],
	i: ['normal', 'italic'],
};
fonts.Vollkorn = {
	v: [
		'regular',
		'italic',
		'600',
		'600italic',
		'700',
		'700italic',
		'900',
		'900italic',
	],
	subset: [
		'cyrillic',
		'cyrillic-ext',
		'latin-ext',
		'greek',
		'vietnamese',
		'latin',
	],
	weight: ['400', '600', '700', '900'],
	i: ['normal', 'italic'],
};
fonts['Vollkorn SC'] = {
	v: ['regular', '600', '700', '900'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400', '600', '700', '900'],
	i: ['normal'],
};
fonts.Voltaire = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Waiting for the Sunrise'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Wallpoet = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Walter Turncoat'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Warnes = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Wellfleet = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Wendy One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Wire One'] = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Work Sans'] = {
	v: ['100', '200', '300', 'regular', '500', '600', '700', '800', '900'],
	subset: ['latin-ext', 'latin'],
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	i: ['normal'],
};
fonts['Yanone Kaffeesatz'] = {
	v: ['200', '300', 'regular', '700'],
	subset: ['cyrillic', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['200', '300', '400', '700'],
	i: ['normal'],
};
fonts.Yantramanav = {
	v: ['100', '300', 'regular', '500', '700', '900'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['100', '300', '400', '500', '700', '900'],
	i: ['normal'],
};
fonts['Yatra One'] = {
	v: ['regular'],
	subset: ['latin-ext', 'devanagari', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Yellowtail = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Yeon Sung'] = {
	v: ['regular'],
	subset: ['korean', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Yeseva One'] = {
	v: ['regular'],
	subset: ['cyrillic', 'cyrillic-ext', 'latin-ext', 'vietnamese', 'latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Yesteryear = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts.Yrsa = {
	v: ['300', 'regular', '500', '600', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal'],
};
fonts.Zeyada = {
	v: ['regular'],
	subset: ['latin'],
	weight: ['400'],
	i: ['normal'],
};
fonts['Zilla Slab'] = {
	v: [
		'300',
		'300italic',
		'regular',
		'italic',
		'500',
		'500italic',
		'600',
		'600italic',
		'700',
		'700italic',
	],
	subset: ['latin-ext', 'latin'],
	weight: ['300', '400', '500', '600', '700'],
	i: ['normal', 'italic'],
};
fonts['Zilla Slab Highlight'] = {
	v: ['regular', '700'],
	subset: ['latin-ext', 'latin'],
	weight: ['400', '700'],
	i: ['normal'],
};
export default fonts;
